import {testIdProps} from '@github-ui/test-id-props'
import {AlertIcon} from '@primer/octicons-react'
import {Box, Text} from '@primer/react'

import {WorkflowResources} from '../../../strings'

interface EmptyQueryMessageProps {
  query: string
  isDirty: boolean
  isAutoAdd?: boolean
}

export const EmptyQueryMessage = (props: EmptyQueryMessageProps) => {
  return props.query.length === 0 && props.isDirty ? (
    <Text
      {...testIdProps('empty-query-message')}
      as="p"
      sx={{
        fontSize: 0,
        fontWeight: 'bold',
        color: props.isAutoAdd ? 'attention.fg' : 'danger.fg',
        mt: 2,
        mb: 0,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Box as="span" sx={{display: 'flex', mr: 1}} aria-hidden="true">
        <AlertIcon size={12} />
      </Box>
      <Text as="span">
        {props.isAutoAdd ? WorkflowResources.emptyFilterAutoAdd : WorkflowResources.emptyFilterDefault}
      </Text>
    </Text>
  ) : null
}

try{ EmptyQueryMessage.displayName ||= 'EmptyQueryMessage' } catch {}